import { useTranslation } from "react-i18next"

import { cn } from "@/utilities/etc"
import { ExpectedError } from "@/utilities/expectedErrors"

import { Button } from "../atoms/Button"
import Heading from "../atoms/Heading"
import Text from "../atoms/Text"
import Modal, { ModalProps } from "../molecules/Modal"

import styles from "./ErrorModal.module.css"

interface ErrorModalProps extends Omit<ModalProps, "isOpen"> {
  error?: Error
}

function ErrorModal(props: ErrorModalProps) {
  const { t } = useTranslation(["common", "errors"])
  return (
    <Modal {...props} isOpen={!!props.error}>
      <Modal.Header hideClose>
        <Heading
          level={2}
          slot="title"
          className={cn("center", styles.errorHeader)}
          style={{ flex: 1, lineHeight: "3.25rem" }}
        >
          {t("common.error", { ns: "errors" })}
        </Heading>
      </Modal.Header>
      <Modal.Body>
        <Text className="center">{errorMessage()}</Text>
      </Modal.Body>
      <Modal.Footer>
        {({ close }) => (
          <Button buttonType="danger" onPress={close}>
            {t("common.dismiss", { ns: "common" })}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )

  function errorMessage() {
    const { error } = props
    if (error instanceof ExpectedError) {
      return t(`${error.translationKey}`, { ns: "errors" })
    }
    return error?.message
  }
}

export default ErrorModal
